import React, { useState } from 'react'

import { TGroup } from 'types/GlobalGroup'

import { useKeyMetric } from 'redux/hooks/KeyMetrics'
import { useKeyMetricActions } from 'redux/actions/KeyMetrics'
import { useParams } from 'utils/hooks'
import { useAccountSettings } from 'redux/hooks/SignedInAccount'
import { useTranslation } from 'language/translator'

import Button from 'components_new/atoms/Button'

import EmptyPlaceholder from 'components_new/molecules/EmptyPlaceholder'
import SectionHeader from 'components_new/molecules/SectionHeader'

import GroupList from 'components_new/organisms/GroupList'

import KeyMetricTemplate from 'components_new/templates/KeyMetricTemplate'

const KeyMetricGroups = () => {
  const { id } = useParams<{ id: string }>()
  const keyMetric = useKeyMetric(id)
  const { t } = useTranslation()
  const { tryUpdateKeyMetric } = useKeyMetricActions()
  const { isAdmin } = useAccountSettings()

  const [edit, setEdit] = useState<boolean>(false)

  if (!keyMetric) return null

  return (
    <KeyMetricTemplate
      subpage={{ icon: { name: 'Groups' }, title: t('global', 'groups') }}
      topbar={{
        actions: isAdmin ? (
          <Button
            onClick={() => setEdit(!edit)}
            variant={edit ? 'contained' : 'text'}
          >
            {t('global', edit ? 'done' : 'edit')}
          </Button>
        ) : undefined
      }}
      variant="feed"
    >
      <SectionHeader
        gutterBottom={true}
        size="large"
        title={t('global', 'groups')}
      />

      {keyMetric.groups.length === 0 && !edit ? (
        <EmptyPlaceholder
          background={true}
          body={t('key_metrics', 'no_groups_body')}
          size="small"
          title={t('key_metrics', 'no_groups_title')}
        />
      ) : null}

      <GroupList
        editMode={edit}
        groups={keyMetric.groups as TGroup[]}
        onAdd={(id) => {
          if (!keyMetric) return

          tryUpdateKeyMetric(keyMetric.id, {
            group_ids: [...keyMetric.groups.map((group) => group.id), id]
          })
        }}
        onRemove={(id) => {
          if (!keyMetric) return

          tryUpdateKeyMetric(keyMetric.id, {
            group_ids: keyMetric.groups
              .map((group) => group.id)
              .filter((gid) => gid !== id)
          })
        }}
      />
    </KeyMetricTemplate>
  )
}

export default KeyMetricGroups
